import { useMutation } from "react-query";
import downloadSkuPoOcrDoc from "../services/downloadSkuPoOcrDoc";

function useDownloadSkuPoOcrDoc() {
  return useMutation(["download-sku-po-ocr-doc"], downloadSkuPoOcrDoc);
}

export default useDownloadSkuPoOcrDoc;
